<template>
  <div>
    <OrganisationName class="tw:mb-4" />
    <InviteUser class="tw:mb-4" />
    <PendingInvitations class="tw:mb-4" />
    <UserRoles />
  </div>
</template>
<script setup>
import OrganisationName from '@/components/settings/teamSettings/OrganisationName.vue'
import InviteUser from '@/components/settings/teamSettings/InviteUser.vue'
import UserRoles from '@/components/settings/teamSettings/UserRoles.vue'
import PendingInvitations from '@/components/settings/teamSettings/PendingInvitations.vue'
</script>
